import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 44 46.8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 44 46.8\" id=\"search\">\r\n<path fill=\"currentColor\" d=\"M43.3,41.8L32.5,30.5c2.8-3.3,4.3-7.5,4.3-11.8c0-10.1-8.3-18.4-18.4-18.4C8.3,0.3,0,8.5,0,18.7c0,10.1,8.3,18.4,18.4,18.4\r\n\tc3.8,0,7.4-1.1,10.5-3.3l10.9,11.4c0.5,0.5,1.1,0.7,1.7,0.7c0.6,0,1.2-0.2,1.7-0.7C44.2,44.3,44.2,42.7,43.3,41.8L43.3,41.8z\r\n\t M18.4,5.1c7.5,0,13.6,6.1,13.6,13.6c0,7.5-6.1,13.6-13.6,13.6c-7.5,0-13.6-6.1-13.6-13.6C4.8,11.2,10.9,5.1,18.4,5.1L18.4,5.1z\r\n\t M18.4,5.1\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol